import styled, { css } from 'styled-components';

export const Styles = styled.div`
    padding: 0 10px;
    transition: left 0.3s ease-out;
    position: relative;

    ${({ simple, isOpenOnMobile, mobileHeight }) =>
        simple
            ? css`
                  width: 100%;
                  height: ${mobileHeight}px;
                  position: absolute;
                  bottom: 0;
                  left: ${!isOpenOnMobile ? '-100%' : '0'};
                  background: white;
                  overflow: auto;
                  padding-bottom: 20px;
              `
            : ''}
`;

export const StyledWrapper = styled.div`
    && {
        background: rgba(255, 255, 255, 0.5);
        z-index: 9;
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        bottom: 0;

        button {
            width: calc(100% - 28px);
            padding: 10px 24px;
            margin: 0 auto;
        }
    }
`;
